import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Form, List, Card, Button, Radio, Checkbox, Switch, message, Spin } from 'antd';
import _ from 'lodash'
import $ from 'jquery'
import { SearchOutlined, CopyOutlined, FormOutlined, ShopOutlined } from '@ant-design/icons';
import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';
import qs from 'query-string';
import InfiniteScroll from 'react-infinite-scroller';
import { genFormItemAtrribute } from 'libs/FormHelper'
import { RadioControl, CheckboxControl } from '@wordpress/components'
import { withState } from '@wordpress/compose';
import bannerImage from 'assets/img/banner/banner-catalog.png';
import { __ } from '@wordpress/i18n';
const defaultListInfo = {
  "current": 1, //目前頁數
  "page_size": 10, //一頁幾筆
  "total": 1, //以此query條件，總共幾筆資料
  "rows": []
}
// 前端頁面
export default class NewsInfo extends Component {
  state = {
    newsInfo: {
      images: []
    },
    data: [],
    loading: false,
    hasMore: true,
  }
  componentDidMount() {
    this.loadData()
  }
  // 抓取頁面資訊
  loadData = () => {
    const search = _.get(window, 'location.search')

    const queryParams = qs.parse(search)

    const id = queryParams.id

    console.log('bb', queryParams)
    if (!id) return;

    this.setState({ isFetchData: true })
    whttp.get(API_HOST + `/api/v1/news/${id}`, null,
      (state, res) => {
        this.setState({ isFetchData: false })

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        console.log(code, reason, data, res)

        if (state === false || code !== 200) {
          message.warning(reason)
          this.props.history.replace('/news')
          return
        }
        this.setState({ newsInfo: data })
        this.handleInfiniteOnLoad()
      })
  }
  handleInfiniteOnLoad = (page) => {
    const newsInfo = _.get(this.state, 'newsInfo')

    this.setState({ loading: true })

    setTimeout(() => {
      const data = _.get(this, 'state.data', [])
      const newData = _.slice(_.get(newsInfo, 'images'), 0, data.length + 1)
      console.log('handleInfiniteOnLoad', page, data, newData)
      this.setState({
        loading: false,
        data: newData,
        hasMore: data.length < newData.length
      })
    }, 100);
  }
  render() {
    const { newsInfo = {} } = this.state;
    const options = _.get(this, 'props.app.options', {})
    const category_ids = _.get(this.props, 'category_ids', [])
    const pdf = _.get(newsInfo, 'pdfs.0')
    return (
      <main class="bg-light">
        <div class="container">
          <h2 class="card-title">{newsInfo.name}</h2>
          
          <div className="col-md-12 px-3 my-3">
            <a class="card card-event" role="button">
              <div class="img-2-1 card-img-top" style={{ backgroundImage: `url(${_.get(newsInfo, 'images.0.url')})` }}></div>
              <div class="card-body">
                <div class="title-head">
                  <h2 class="card-title">{newsInfo.name}</h2>
                  <span class="date">{newsInfo.start_date}-{newsInfo.end_date}</span>
                </div>
                <p class="card-text">{newsInfo.desc}</p>
              </div>
            </a>
          </div>
          <section class="pt-md-5">
            {pdf && <a href={pdf} target="_blank" > {__('PDF下載','cec-plugin-stores')}</a>}
            <InfiniteScroll
              initialLoad={true}
              pageStart={0}
              loadMore={this.handleInfiniteOnLoad}
              hasMore={!this.state.loading && this.state.hasMore}
            // useWindow={false}
            >
              <List
                grid={{ gutter: 16, xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2, }}
                dataSource={this.state.data}
                renderItem={(imageInfo, idx) => (
                  <List.Item key={idx}>
                    <img src={_.get(imageInfo, 'url')} alt="目錄" style={{ width: '100%' }} />
                  </List.Item>
                )}
              >
                {this.state.loading && this.state.hasMore && (
                  <div className="demo-loading-container">
                    <Spin />
                  </div>
                )}
              </List>
            </InfiniteScroll>
          </section>
        </div>
      </main>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4, }
export class NewsInfoEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
  }
  // 抓取頁面資訊
  fetchData = () => {
    const id = _.get(this, 'props.match.params.id')

    if (!id) return;

    this.setState({ isFetchData: true })
    whttp.get(API_HOST + `/api/v1/news/${id}`, null,
      (state, res) => {
        this.setState({ isFetchData: false })

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        console.log(code, reason, data, res)

        if (state === false || code !== 200) {
          message.warning(reason)
          this.props.history.replace('/news')
          return
        }

        this.fillData(data)

      })
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className="vu-blocks-editor">
        <h2>促銷目錄內容</h2>
      </div>
    )
  }
}  


// WEBPACK FOOTER //
// ./src/blocks/news/news-info.js